import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  detailText: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
  exampleText: {
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
  selectRoot: {
    borderRadius: '8px',
    '& .MuiSelect-root': {
      height: '32px',
      padding: '0px 16px 0px',
      display: 'flex',
      alignItems: 'center',
      width: '120px',
      fontSize: '13px',
    },
  },
}));
